// extracted by mini-css-extract-plugin
export default {"main":"_3e9b02dd19","tit":"_992406d7c8","maintitle":"e4b3797c26","ylw":"_284a5cad71","white":"_4fc61a7498","mv_title":"_62e0a28860","mv_nc":"_49d088d0c5","mv_in":"a6acd7a3a2"};